export class TransportSectionFieldAliases {
  static TYPE = 'type'
  static NUMBER = 'number'
  static TRAILER = 'trailer'
  static MARK = 'mark'
  static MODEL = 'model'
  static COLOR = 'color'
  static OWNER = 'owner'
  static USER_POSITION = 'user_position'
}
